import React from 'react';
import Footer from '../Footer/Footer';
import Konten from './Konten';

const Video = (props) => {

  return (
    <div className="text-center">
      <Konten />
      <Footer></Footer>
    </div>
  )
};

export default Video;
